export enum NdsTextSizes {
  S = 'small',
  M = 'medium',
  L = 'large',
}
